var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigcommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#34313F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,28.5h6.2c1.8,0,2.9-1,2.9-2.5c0-1.5-1.1-2.5-2.9-2.5h-6.2c-0.2,0-0.4,0.2-0.4,0.4v4.4 C26,28.3,26.2,28.5,26.4,28.5z M26.4,38.5h6.4c2,0,3.2-1,3.2-2.8c0-1.5-1.1-2.8-3.2-2.8h-6.4c-0.2,0-0.4,0.2-0.4,0.4v4.8 C26,38.4,26.2,38.5,26.4,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,0.5L30.7,18.9h3c4.7,0,7.5,2.9,7.5,6.2c0,2.5-1.7,4.4-3.5,5.2c-0.3,0.1-0.3,0.5,0,0.6 c2.1,0.8,3.6,3,3.6,5.6c0,3.7-2.4,6.6-7.2,6.6h-13c-0.2,0-0.4-0.2-0.4-0.4V28.9L0.5,49c-0.3,0.3-0.1,0.7,0.3,0.7h48.5 c0.2,0,0.3-0.1,0.3-0.3V0.8C49.8,0.5,49.4,0.3,49.1,0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcommerce);
export default __webpack_public_path__ + "static/media/bigcommerce.924220a2c1121f15d89558b02ac18447.svg";
export { ForwardRef as ReactComponent };